import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import Modal_Item_Add from "../item/modalItemAdd";
import Select from "react-select";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Str,Log,DateTime} from "biz9-utility";
import {Portal_Type,Portal_Table,Portal_Remote_Data,Portal_Remote_CMS,Portal_Url} from "biz9-portal-app";
import {Image_Format} from "biz9-image";
import {Store_Logic} from "biz9-store";
import {Config,CMS_Config,Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_App_Product = () => {
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.PRODUCT,{plural:true}));
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [products,setProducts] = useState([]);
    const [val_type,setValType] = useState(null);
    const [types,setTypes] = useState([]);
    const [val_category,setValCategory] = useState(null);
    const [categorys,setCategorys] = useState([]);
    // -- paging --
    const [val_page_current,setValPageCurrent] = useState(Type.PAGE_CURRENT);
    const [val_page_size,setValPageSize] = useState(Type.PAGE_SIZE);
    const [val_total,setValTotal] = useState(0);
    const [val_filter,setValFilter] = useState({});
    const [val_sort_by,setValSortBy] = useState({});
    const [val_option,setValOption] = useState({});

    const columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_app_product_edit+"?id="+record.id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_app_product_edit+"?id="+record.id} className="text-dark">
                   {Str.get_truncate(record.title,CMS_Config.ITEMS_TITLE_COUNT)}
                   </Link>
                   </h2>
                   ),
            sorter: true
    },
    {
title: 'Cost',
       dataIndex: 'cost',
       key: 'id',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.cost)} <br/>
               </>
               ),
            sorter: true
    },
    {
title: "Date",
       dataIndex: "date_create",
       key: "date_create",
       render: (text: string, record: any) => (
               <>
               {DateTime.get_pretty(record.date_create)}
               </>
               ),
            sorter: true
    },
    {
title: "Type",
       dataIndex: "Type",
       key: "id",
       render: (text: string, record: any) => (
               <>
               {record.type}
               </>
               ),
            sorter: true
    },
    {
title: "Category",
       dataIndex: "category",
       key: "id",
            sorter: true
    },
    {
title: "Visible",
       dataIndex: "setting_visible",
       key: "id",
       render: (text: string, record: any) => (
               <>
               {record.setting_visible =="1" ? <FeatherIcon icon="plus" /> :<FeatherIcon icon="minus" />}
               </>
               ),
            sorter: true
    },
    {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">

                <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_preview(record.title_url)} }} >
               <FeatherIcon icon="copy" /> {Title.LABEL_PREVIEW}
               </Link>
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_copy(record.id)} }} >
               <FeatherIcon icon="copy" /> {Title.LABEL_COPY}
               </Link>

               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_delete(record.id)} }} >
               <FeatherIcon icon="trash" /> {Title.LABEL_DELETE}
               </Link>
               </div>
               </div>
               </>
               ),
    },
    ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data() {
        let search = Data_Logic.get_search(Portal_Table.PRODUCT,val_filter,{page_current:val_page_current,page_size:40, sort_by:{date_create:-1}});
        let [response,data] = await Portal_Remote_CMS.search(App.get_url(Portal_Url.CMS_SEARCH),search,{category:Portal_Table.PRODUCT});
        Log.w('11_search',search);
        Log.w('11_response',response);
        Log.w('11_data',data);
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_items(data){
        let set_types = Data.get_type_categorys(data.types,{any:true});
        setTypes(set_types);
        let set_categorys = Data.get_type_categorys(data.categorys,{any:true});
        setCategorys(set_categorys);
        setProducts(data[Portal_Type.ITEMS]);
        setValTotal(data[Portal_Type.ITEM_COUNT]);
    };
    const post_search = (e) => {
        const value = Str.get_trim(e.target.value);
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setStopSearch(value);
            let filter = {};
            if(value){
                filter = Data.get_item_search_filter(value);
            }
            let search = Data_Logic.get_search(Portal_Table.PRODUCT,filter);
            post_search_data(search);
        }, 500);
    };
    async function post_search_data(search) {
        Toast_Message.loading(Message.SEARCHING);
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);
        setProducts(data[Portal_Type.ITEMS]);
        setValTotal(data[Portal_Type.ITEM_COUNT]);
        Toast_Message.dismiss();
    }
    async function btn_post_copy(id: any) {
        if (window.confirm(Message.CONFIRM)) {
            Toast_Message.loading(Message.SAVING);
            let [response,data] = await Portal_Remote_CMS.copy(App.get_url(Portal_Url.CMS_COPY),Portal_Table.PRODUCT,id);
            setProducts([data, ...products]);
            Toast_Message.success(response.message);
        }
    };
    async function btn_post_preview(title_url: any) {
        let url = Storage.get_app().url + "/appz/"+ title_url;
        window.open(url, "_blank", "noopener,noreferrer");
    };
    async function btn_post_delete(id: any) {
        if(window.confirm(Message.CONFIRM)){
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_CMS.delete_ids(App.get_url(Portal_Url.CMS_DELETE_IDS),Portal_Table.PRODUCT,[id]);
            Toast_Message.success(response.message);
            setProducts(products.filter(item=>item.id!==id));
        }
    };
    const updateNewItem = (item) => {
        setProducts([item, ...products]);
    };
    const updateValType = (selectedOption) => {
        let search = Data_Logic.get_search(Portal_Table.PRODUCT,Data.get_type_category_search_filter(selectedOption.label,val_category?val_category.label:Title.LABEL_ANY));
        post_search_data(search);
        setValType(selectedOption);
    };
    const updateValCategory = (selectedOption) => {
        let search = Data_Logic.get_search(Portal_Table.PRODUCT,Data.get_type_category_search_filter(val_type?val_type.label:Title.LABEL_ANY,selectedOption.label));
        Log.w('33_prod_prod_search',search);
        post_search_data(search);
        setValCategory(selectedOption);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input  type='text' autoComplete='off' className='form-control' placeholder={Title.LABEL_SEARCH} value={val_search} onChange={post_search}  />
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            {Title.LABEL_ADD}
    </Link>
        </div>
        </div>
        <div className="table-filter pb-4">
        <ul className="filter-item">
        <li>
        <div className="dropdown">
        <Select placeholder={'Filter Type'} classNamePrefix="react-select" className="select" styles={Style.customStyles}  options={types} value={val_type} onChange={updateValType} />
        </div>
        </li>
        <li>
        <div className="dropdown">
        <Select  placeholder={'Filter Category'}   classNamePrefix="react-select" className="select" styles={Style.customStyles} options={categorys} value={val_category} onChange={updateValCategory} />
        </div>
        </li>
        </ul>
        </div>
        <div className="table-responsive custom-table">
<Table onUpdate={setProducts} allow_multiple={true}  page_size={val_page_size} page_current={val_page_current} total={val_total} option={val_option} sort_by={val_sort_by} filter={val_filter} table={Portal_Table.PRODUCT} dataSource={products} columns={columns} Selection={false} />
        </div>
        <div className="table-footer">
        <div id="tablepage" />
        </div>
        </div>
        {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
    <Modal_Item_Add toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} onUpdate={updateNewItem} table={Portal_Table.PRODUCT}/>
        </>
        );
};
export default Dashboard_App_Product;
